import React, { Component, useEffect, useRef, useState } from 'react';
import { Container, Nav, Navbar, NavDropdown, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendars, faChartSimpleHorizontal, faPencil, faTable } from '@fortawesome/pro-solid-svg-icons';
import '../pickers/pickers.scss'
import { Calendar } from 'primereact/calendar';
import { is } from 'date-fns/locale';
import { addLocale } from 'primereact/api';
import { Toast } from 'primereact/toast';
import { set } from 'lodash';
import moment from 'moment';
import { useTranslation } from "react-i18next";

const MultipleDatePicker = (props) => { // props: {selectedDate,selectedDateLast }

    const { t, i18n } = useTranslation();
    const calendarLocale = i18n.language === 'en-US' ? 'en' : 'tr';
    const [firstDate, setFirstDate] = useState();
    const [lastDate, setLastDate] = useState();
    const [isVisible, setIsVisible] = useState(false);
    const [date, setDate] = useState(null);
    const toast = useRef(null);

    addLocale('tr', {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: ['pazartesi', 'salı', 'çarşamba', 'perşembe', 'cuma', 'cumartesi', 'pazar'],
        dayNamesShort: ['pzt', 'sal', 'çar', 'per', 'cum', 'cmt', 'paz'],
        dayNamesMin: ['P', 'S', 'Ç', 'P', 'C', 'C', 'P'],
        monthNames: ['ocak', 'şubat', 'mart', 'nisan', 'mayıs', 'haziran', 'temmuz', 'ağustos', 'eylül', 'ekim', 'kasım', 'aralık'],
        monthNamesShort: ['ock', 'şbt', 'mrt', 'nsn', 'mays', 'hzr', 'tmz', 'ağs', 'eyl', 'ekm', 'ksm', 'arl'],
        today: 'Bugün',
        clear: 'Temizle',
    });

    useEffect(() => {
        if (props.firstDate) {
            setFirstDate(props.firstDate);
        }
        else {
            setFirstDate(new Date());
        }
        if (props.lastDate) {
            setLastDate(props.lastDate);
        }
        else {
            setLastDate(new Date());
        }
    }, [props.firstDate, props.lastDate]);


    const selectedFirstDate = (event) => {
        if (moment(event) < moment(lastDate)) {
            setFirstDate(event);
        }

        else {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: t('startDateEndDateInfo'), life: 3000 });
            setFirstDate(new Date());
        }
    }

    const selectedLastDate = (event) => {

        if (moment(event) > moment(firstDate)) {
            setLastDate(event);
        }

        else {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('startDateEndDateInfo'), life: 3000 });
            setLastDate(new Date());
        }
    }


    const applyDate = () => {


        if (moment(firstDate) > moment(lastDate)) {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('startDateEndDateInfo'), life: 3000 });
            return;
        }

        else {
            setIsVisible(!isVisible);
            props.selectedDate(firstDate, lastDate);
        }

        // setIsVisible(!isVisible);
        // props.selectedDate(firstDate, lastDate);
        // props.selectedDateLast(lastDate);
    }

    return (

        <div className="MultipleDatePicker" >
            <Toast ref={toast} />

            <div className='options-row ' onClick={() => setIsVisible(!isVisible)} >
                <div className='date-picker-icon-bg'>
                    <FontAwesomeIcon className='table-chart-icon' icon={faCalendars} />
                </div>
            </div>

            {isVisible &&
                <div className="card picker-card" >
                    <div className="card-body">

                        <Container>
                            <Row>
                                <Col md='6' xs='6'>
                                    <label className='roboto-bold-12 title'>
                                        {t('startDate')}
                                    </label>

                                </Col>

                                <Col md='6' xs='6'>
                                    <label className='roboto-bold-12 title'>
                                        {t('endDate')}
                                    </label>

                                </Col>
                            </Row>
                            <Row>
                                <Col md='6' xs='6' >
                                    <div className="" >
                                        {/* <Calendar onChange={(event) => props.selectedDate(event)} dateFormat="dd/mm/yy" /> */}

                                        <Calendar value={firstDate} onChange={(e) => selectedFirstDate(e.value)} dateFormat="dd/mm/yy" locale={calendarLocale} />

                                    </div>
                                </Col>

                                <Col md='6' xs='6' >
                                    <div className="" >
                                        {/* <Calendar onChange={(event) => props.selectedDateLast(event)} dateFormat="dd/mm/yy" locale='tr' /> */}

                                        <Calendar value={lastDate} onChange={(e) => selectedLastDate(e.value)} dateFormat="dd/mm/yy" locale={calendarLocale} />

                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col md='6' xs='6' >
                                    <div className=" flex justify-content-center" >
                                        <Button onClick={() => setIsVisible(!isVisible)} className='cancel-button btn btn-primary roboto-bold-14 ' >
                                            {t('cancel')}
                                        </Button>
                                    </div>
                                </Col>
                                <Col md='6' xs='6' >
                                    <div className=" flex justify-content" >
                                        <Button onClick={() => applyDate()} className='apply-button btn btn-primary roboto-bold-14 ' >
                                            {t('apply')}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </div>
            }
        </div>
    );
}

export default MultipleDatePicker;
